import { render, staticRenderFns } from "./TextConfig.vue?vue&type=template&id=a92c62b2&scoped=true"
import script from "./TextConfig.vue?vue&type=script&lang=js"
export * from "./TextConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92c62b2",
  null
  
)

export default component.exports